import { render, staticRenderFns } from "./DisasterTableWin.vue?vue&type=template&id=492730ad&scoped=true&"
import script from "./DisasterTableWin.vue?vue&type=script&lang=js&"
export * from "./DisasterTableWin.vue?vue&type=script&lang=js&"
import style0 from "./DisasterTableWin.vue?vue&type=style&index=0&id=492730ad&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492730ad",
  null
  
)

export default component.exports